import { render } from "./Talleres.vue?vue&type=template&id=05e7ad6c"
import script from "./Talleres.vue?vue&type=script&lang=js"
export * from "./Talleres.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__